<template>
  <div class="app_introduce">
    <!-- <moe-top></moe-top> -->
    <div class="introduce_one">
      <div class="one_content">
        <div class="one_top flex Flexalign">
          <el-image
            class="app_logo"
            :src="imgPath('app_logo.png')"
          ></el-image>
          <div class="ml-30">
            <div class="one_title">逆熵问学云</div>
            <div class="one_subtitle mt-10">逆熵启航 升学有方</div>
          </div>
        </div>
        <div class="one_desc">
          逆熵问学云平台，基于“四轮七阶五步学习法”：四轮含系统学习、专题提升、热点技巧聚焦、调适应试；七阶从导入至探索循序渐进；五步有学习输入等。平台以此为核心，支持选购适合自己的课程，用方法提效率，用流程保结果，助力高效学习。
        </div>
      </div>
    </div>
    <div class="introduce_one introduce_two">
      <div class="two_title">能力测评</div>
      <div class="two_desc">
        通过阶段测试、闯关
        PK、整卷测等，全面分析学生知识、能力与综合学习力，精准定位优劣势，支撑个性化提升。
      </div>
    </div>
    <div class="introduce_one introduce_three">
      <div class="three_title">问答</div>
      <div class="three_desc">
        借助 Deepseek
        学习问答功能，通过解答赚分、发题求解的闭环交互，提升学生自主学习与问题解决能力。
      </div>
    </div>
    <div class="introduce_one introduce_four">
      <div class="three_title four_title">消息</div>
      <div class="three_desc four_desc">
        整合签到、学习任务、学习数据及个人订单，形成集多元功能于一体的综合性学习与个人管理中心，为用户提供学习事务与个人信息的集中化、便捷化管理服务。
      </div>
    </div>
    <div class="introduce_one introduce_five">
      <div class="three_title five_title">我的</div>
      <div class="three_desc five_desc">
        整合签到、学习任务、学习数据及个人订单，形成集多元功能于一体的综合性学习与个人管理中心，为用户提供学习事务与个人信息的集中化、便捷化管理服务。
      </div>
    </div>
    <moe-bottom></moe-bottom>
  </div>
</template>

<script>
export default {
  name: "GjkcH5Index",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.app_introduce {
  width: 100%;
  .introduce_one {
    box-sizing: border-box;
    width: 100%;
    height: 760px;
    background-image: url("/public/static/img/app_bg1.png");
    background-size: cover;
    .one_content {
      .one_top {
        padding-left: 930px;
        padding-top: 190px;
        .app_logo {
          width: 118px;
          height: 118px;
          border-radius: 10px;
        }
        .one_title {
          font-weight: 600;
          font-size: 36px;
          color: #333333;
          line-height: 50px;
        }
        .one_subtitle {
          font-size: 20px;
          color: #606060;
          line-height: 28px;
        }
      }
      .one_desc {
        padding-left: 930px;
        padding-top: 15px;
        font-weight: 500;
        width: 625px;
        height: 225px;
        line-height: 45px;
        color: #303030;
        font-size: 24px;
      }
    }
  }
  .introduce_two {
    background-image: url("/public/static/img/app_bg2.png");
    .two_title {
      font-weight: 600;
      font-size: 63px;
      color: #333333;
      line-height: 88px;
      padding-top: 40px;
      padding-left: 830px;
    }
    .two_desc {
      padding-top: 20px;
      padding-left: 530px;
      width: 856px;
      height: 84px;
      font-family: PingFang-SC, PingFang-SC;
      font-weight: 500;
      font-size: 24px;
      color: #303030;
      line-height: 42px;
      text-align: center;
    }
  }
  .introduce_three {
    background-image: url("/public/static/img/app_bg3.png");
    .three_title {
      padding-top: 234px;
      padding-left: 955px;
      font-weight: 600;
      font-size: 63px;
      color: #333333;
      line-height: 88px;
    }
    .three_desc {
      width: 559px;
      height: 126px;
      padding-top: 30px;
      padding-left: 955px;
      font-weight: 500;
      font-size: 24px;
      color: #303030;
      line-height: 42px;
    }
  }
  .introduce_four {
    background-image: url("/public/static/img/app_bg4.png");
    .four_title {
      padding-top: 237px;
      padding-left: 410px;
      font-weight: 600;
      font-size: 63px;
      color: #333333;
      line-height: 88px;
    }
    .four_desc {
      width: 531px;
      height: 168px;
      padding-top: 45px;
      padding-left: 410px;
      font-size: 26px;
      color: #303030;
      line-height: 42px;
      line-height: 42px;
    }
  }
  .introduce_five {
    background-image: url("/public/static/img/app_bg5.png");
    .five_title {
      padding-top: 220px;
      padding-left: 895px;
      font-weight: 600;
      font-size: 63px;
      color: #333333;
      line-height: 88px;
    }
    .five_desc {
      width: 651px;
      height: 126px;
      padding-top: 30px;
      padding-left: 895px;
      font-weight: 500;
      font-size: 24px;
      color: #303030;
      line-height: 42px;
    }
  }
}
</style>